interface ProviderOption {
  label: string;
  value: string;
  type: 'Telephony' | 'LLM' | 'Voice' | 'Transcription' | 'Workflow' | 'Auth';
  hidden?: boolean;
  required?: string[];
}

export const nonApiKeyConnections = [
  'account_connection_twilio',
  'account_connection_openai',
  'account_connection_login_key_oauth',
  'account_connection_un_pw_oauth',
];

export const providerOptions: ProviderOption[] = [
  {
    label: 'Twilio',
    value: 'account_connection_twilio',
    type: 'Telephony',
    required: ['twilio_account_sid', 'twilio_auth_token'],
  },
  {
    label: 'OpenAI',
    value: 'account_connection_openai',
    type: 'LLM',
    required: ['openai_api_key'],
  },
  {
    label: 'Telnyx',
    value: 'account_connection_telnyx',
    type: 'Telephony',
    required: ['public_key', 'api_key'],
  },

  {
    label: 'ElevenLabs',
    value: 'account_connection_elevenlabs',
    type: 'Voice',
    required: ['api_key'],
  },
  {
    label: 'Deepgram',
    value: 'account_connection_deepgram',
    type: 'Transcription',
    required: ['api_key'],
  },
  {
    label: 'Gladia',
    value: 'account_connection_gladia',
    type: 'Transcription',
    required: ['api_key'],
  },
  {
    label: 'AssemblyAI',
    value: 'account_connection_assemblyai',
    type: 'Transcription',
    required: ['api_key'],
  },
  {
    label: 'Cartesia',
    value: 'account_connection_cartesia',
    type: 'Voice',
    required: ['api_key'],
  },
  {
    label: 'PlayHT',
    value: 'account_connection_playht',
    type: 'Voice',
    required: ['api_key', 'userId'],
    hidden: true,
  },
  {
    label: 'Rime',
    value: 'account_connection_rime',
    type: 'Voice',
    required: ['api_key'],
  },
  {
    label: 'Azure Speech',
    value: 'account_connection_azure_speech',
    type: 'Voice',
    required: ['api_key', 'region'],
  },
  {
    label: 'Google',
    value: 'account_connection_google',
    type: 'LLM',
    required: ['api_key'],
  },
  {
    label: 'Azure LLM',
    value: 'account_connection_azure_llm',
    type: 'LLM',
    required: ['api_key', 'url'],
  },
  {
    label: 'DeepSeek',
    value: 'account_connection_deepseek',
    type: 'LLM',
    required: ['api_key'],
  },
  {
    label: 'Together AI',
    value: 'account_connection_togetherai',
    type: 'LLM',
    required: ['api_key'],
  },
  {
    label: 'Login Key Auth',
    value: 'account_connection_login_key_oauth',
    type: 'Auth',
    hidden: true,
  },
  {
    label: 'API Key Auth',
    value: 'account_connection_external_api_key',
    type: 'Auth',
    required: ['api_key'],
  },
  {
    label: 'Username Password Oauth',
    value: 'account_connection_un_pw_oauth',
    type: 'Auth',
    hidden: true,
  },
];
